export default "__VITE_ASSET__Tvv9Ldex__"